"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (config, win, vant, md5, axios, Vue, gData, ras) {
  var Toast = vant.Toast;
  Toast.allowMultiple(config.toastAllowMultiple); // Vue.use(Toast);
  // const merge = function (config, options) {
  //     for(let k in options){
  //         config[k] = options[k];
  //     }
  //     return config;
  // };

  /**
   * 实现每个页面一个独立存储空间
   * @param type
   * @param options
   */

  var storageManage = function storageManage(type, options) {
    var config = {
      id: ""
    };
    this.type = type;
    this.options = Object.assign(config, options); // 为每个页面分配一个唯一的ID

    if (!this.options.id) {
      this.id = md5("/page" + window.location.pathname);
    } else {
      this.id = this.options.id;
    }

    this.values = JSON.parse(window[this.type].getItem(this.id) || "{}");
  };

  storageManage.prototype.getItem = function () {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (key === null) {
      return this.values;
    }

    return this.values[key];
  };

  storageManage.prototype.setItem = function (key, val) {
    this.values[key] = val;
    window[this.type].setItem(this.id, JSON.stringify(this.values));
  };

  storageManage.prototype.removeItem = function (key) {
    delete this.values[key];
    window[this.type].setItem(this.id, JSON.stringify(this.values));
  };

  storageManage.prototype.clear = function () {
    window[this.type].setItem(this.id, "{}");
  };

  storageManage.prototype.setRefreshData = function (value) {
    this.setItem("__refresh_data__", value);
  };

  storageManage.prototype.getRefreshData = function () {
    return this.getItem("__refresh_data__");
  };
  /**
   * 本地参数，可以设置指定页面的参数
   * @param key
   * @param val
   * @returns {string|boolean}
   */


  var local = new storageManage("localStorage"); // const localData = local.getItem();

  /**
   * 会话参数
   * @param key
   * @param val
   * @returns
   */

  var session = new storageManage("sessionStorage"); // const sessionData = session.getItem();

  /**
   * 生成Get请求字符串
   * @param query_data {object} JSON 对象
   * @param numeric_prefix {string} get参数前缀
   * @param arg_separator {string} 拼接符号
   * @param enc_type {function} 转义函数
   * @returns {string}
   */

  var httpBuildQuery = function httpBuildQuery(query_data) {
    var numeric_prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var arg_separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "&";
    var enc_type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : encodeURIComponent;
    var data = [];

    for (var key in query_data) {
      data.push("".concat(numeric_prefix).concat(key, "=") + enc_type(query_data[key]));
    }

    return data.join(arg_separator);
  };
  /**
   * 获取GET参数
   * @param variable {string}
   * @param default_val {string|null}
   * @returns {string|null|*}
   */


  var query = function query() {
    var variable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var default_val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var urlparameter = window.location.search.substring(1);
    var entities = new DOMParser().parseFromString(urlparameter, "text/html"); //解码html实体

    var query = entities.documentElement.textContent; //获取解码字符串

    var result = {};

    if (!!query) {
      var vars = query.split("&");

      if (vars.length === 0) {
        return default_val;
      }

      for (var i = 0, l = vars.length; i < l; i++) {
        var pair = vars[i].split("=");

        if (!!pair[0]) {
          result[pair[0]] = pair[1] || default_val;
        }
      }
    }

    if (typeof variable === "string" && variable !== "") {
      return result[variable] || default_val;
    }

    return result;
  };
  /**
   * 获取当前时间戳，秒级
   * @returns {number}
   */


  var time = function time() {
    var date = new Date();
    return Math.round(date.getTime() / 1000);
  };
  /**
   * 获取时间格式
   * @param f
   * @param t
   * @returns {string}
   */


  var date = function date(f) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    // f: Y y m d h i s
    if (t === null) {
      t = utils.time();
    }

    var date = new Date();
    date.setTime(t * 1000);
    var year = date.getFullYear();
    var year2 = year % 100;
    var month = date.getMonth() + 1;
    month = month > 9 ? "".concat(month) : "0".concat(month);
    var day = date.getDate();
    day = day > 9 ? "".concat(day) : "0".concat(day);
    var hour = date.getHours();
    hour = hour > 9 ? "".concat(hour) : "0".concat(hour);
    var minute = date.getMinutes();
    minute = minute > 9 ? "".concat(minute) : "0".concat(minute);
    var second = date.getSeconds();
    second = second > 9 ? "".concat(second) : "0".concat(second);
    return f.replace(/(.*)(Y)(.*)/g, "$1".concat(year, "$3")).replace(/(.*)(y)(.*)/g, "$1".concat(year2, "$3")).replace(/(.*)(m)(.*)/g, "$1".concat(month, "$3")).replace(/(.*)(d)(.*)/g, "$1".concat(day, "$3")).replace(/(.*)(h)(.*)/g, "$1".concat(hour, "$3")).replace(/(.*)(i)(.*)/g, "$1".concat(minute, "$3")).replace(/(.*)(s)(.*)/g, "$1".concat(second, "$3"));
  }; // 是否是微信浏览器


  var isWeiXin = function isWeiXin() {
    var ua = win.navigator.userAgent.toLowerCase();
    var reg = new RegExp("MicroMessenger", "gi");
    return reg.test(ua);
  }; // 微信浏览器中登录


  var wxLogin = function wxLogin(callback) {
    if (isWeiXin()) {
      if (!win.localStorage.getItem(config.userLogin)) {
        // 需要去登录
        var code = query("code");

        if (!code) {
          var url = encodeURIComponent(window.location.href); // alert(encodeURIComponent(window.location.href))

          win.sessionStorage.setItem("global.refer.code.url", url);
          window.location.replace("https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + gData.wxAppId + "&redirect_uri=" + url + "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect");
          return true;
        }

        axios.post("/api/user/third_login", {
          source: "wx",
          code: query("code", "0") // first_leader: query('first_leader', '0'),

        }).then(function (res) {
          if (res.code === 0) {
            if (res.data.is_new == 1) {
              win.location.href = "../sign/registered.html?scene=" + 1 + "&open_id=" + res.data.open_id + "&first_leader=" + query("first_leader", "0") + "&client=" + query("client", "0");
            } else {
              var redirect = win.sessionStorage.getItem("global.refer.code.url");
              win.localStorage.setItem(config.userTokenKey, res.data.token);

              if (decodeURIComponent(win.localStorage.getItem("return_url")) != "null") {
                win.location.href = decodeURIComponent(win.localStorage.getItem("return_url"));
              } else {
                win.location.href = "../index/index.html";
              }
            }

            callback && callback();
          } else {
            toast("登录失败");
            win.localStorage.removeItem(config.userLogin);
          }
        })["catch"](function (err) {
          toast("登录失败");
          win.localStorage.removeItem(config.userLogin);
        });
      } else {
        callback && callback();
      }
    } else {
      callback && callback();
    }
  };
  /**
   * 返回历史页面，刷新
   */


  var refresh_key = config.refreshKey;
  var refresh_data_key = config.refreshDataKey;

  var backRefresh = function backRefresh() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    window.sessionStorage.setItem(refresh_key, "true");
    window.sessionStorage.setItem(refresh_data_key, JSON.stringify(data));
    window.history.back();
  };

  var goRefresh = function goRefresh(g) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    window.sessionStorage.setItem(refresh_key, "true");
    window.sessionStorage.setItem(refresh_data_key, JSON.stringify(data));
    window.history.go(g);
  };

  var silentRefresh = function silentRefresh() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    window.sessionStorage.setItem(refresh_key, "true");
    window.sessionStorage.setItem(refresh_data_key, JSON.stringify(data));
  };

  var backRefreshInit = function backRefreshInit() {
    var silentRefreshData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    window.addEventListener("pageshow", function (e) {
      if (window.sessionStorage.getItem(refresh_key) === "true") {
        // if(e.persisted) {
        //     // ios 有效, android 和 pc 每次都是 false
        //     win.location.reload();
        // }else{
        //     // ios 除外
        //     win.location.reload();
        // }
        // 在判断完成后，一定要删除之前的存储(remove)避免出现无限重载的情况
        window.sessionStorage.removeItem(refresh_key);
        session.setRefreshData(JSON.parse(window.sessionStorage.getItem(refresh_data_key) || "{}")); // 通用写法

        window.location.reload();
      } // else if(silentRefreshData){
      //              // 存在静默刷新，按物理按钮会自动返回刷新
      //              silentRefresh(silentRefreshData);
      //          }

    });

    if (window.sessionStorage.getItem(refresh_key) !== "true") {
      var data = window.sessionStorage.getItem(refresh_data_key);

      if (!!data) {
        window.sessionStorage.removeItem(refresh_data_key);
        window.persistedRefreshData = JSON.parse(data);
      } else {
        window.persistedRefreshData = {};
      }

      window.sessionRefreshData = session.getRefreshData() || {};
    } else {
      // 必须返回一个对象，好判断
      window.persistedRefreshData = {};
      window.sessionRefreshData = {};
    }
  };

  var backRefreshClear = function backRefreshClear() {
    window.sessionStorage.removeItem(refresh_key);
    window.sessionStorage.removeItem(refresh_data_key);
  };
  /**
   * 全局ajax
   */
  // axios.defaults.baseURL = 'http://rap2api.taobao.org/app/mock/271893';
  // axios.defaults.baseURL = 'http://zhd-h5-api.test.zsyh99.com';
  // axios.defaults.baseURL = config.baseURL;
  // 添加请求拦截器


  axios.interceptors.request.use(function (conf) {
    // console.log('request', conf);
    var key = "DG85ocvXcHFiG211q4Nd6pSndUGCNKBl7W";
    var timestamp = time();
    var type = "h5"; // 在发送请求之前做些什么

    var user_token = window.localStorage.getItem(config.userTokenKey);
    conf.headers["X-Header-Submit"] = "1";

    if (!!user_token) {
      conf.headers["X-Header-Token"] = user_token;
    } // config.headers['X-Header-Token'] = 'application/json';


    conf.headers["X-Header-Sign"] = md5("X-Header-Submit=1&X-Header-Timestamp=".concat(timestamp, "&X-Header-Type=").concat(type, "&key=").concat(key));
    conf.headers["X-Header-Timestamp"] = timestamp;
    conf.headers["X-Header-Type"] = type; // throw new Error("出错了");

    return conf;
  }, function (error) {
    console.error("request", error);
    return Promise.reject(error);
  }); // 添加响应拦截器

  axios.interceptors.response.use(function (response) {
    // console.log('response', response);
    if ("selfRaw" in response.config && response.config.selfRaw) {
      return response;
    }

    if (!response.data) {
      Toast("系统异常");
      return null;
    }

    if (response.data.code !== 0) {
      Toast({
        message: response.data.message,
        position: "bottom"
      });

      if (response.data.code == 100007 || response.data.code == 100006) {
        // 需要登录
        win.localStorage.setItem("return_url", encodeURIComponent(window.location.href));
        win.localStorage.removeItem(config.userLogin);
        win.location.href = "../sign/sign.html"; // win.location.href='../sign/sign.html?first_leader=' + query('first_leader', '0') + '&client=' + query('client', '0')
        // if(isWeiXin()){
        //     let n = parseInt(win.sessionStorage.getItem('global.user_repeat_login') || '0');
        //     // if(n++ < 3){
        //     //     win.sessionStorage.setItem('global.user_repeat_login', `${n}`);
        //     //     win.location.reload();
        //     // }
        // }
      }
    }

    return response.data;
  }, function (error) {
    console.error("response", error);

    if (error.response) {
      // 发出了请求，服务器返回了状态码
      // 超出2xx的范围
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // 已提出请求，但未收到回复
      // error.request是浏览器中XMLHttpRequest的一个实例，也是
      // node.js中的http.ClientRequest
      console.log(error.request);
    } else {
      // throw new Error 的错误。设置触发错误的请求时发生了什么
      console.log("Error", error.message);
    }

    console.log(error.config); // 对响应错误做点什么

    return Promise.reject(error);
  }); // 将常用的axios函数部分代理到工具中
  // axios.get(url[, config])
  // utils.get = a.get;
  // axios.delete(url[, config])
  // axios.head(url[, config])
  // axios.options(url[, config])
  // axios.post(url[, data[, config]])
  // utils.post = a.post;
  // axios.put(url[, data[, config]])
  // axios.patch(url[, data[, config]])
  // 处理并发请求的助手函数
  // axios.all(iterable)
  // utils.all = a.all;
  // axios.spread(callback)
  // utils.spread = a.spread;
  // 添加jsonp请求

  axios.jsonp = function (url, data, p) {
    if (!url) throw new Error("url is necessary");
    var callback = p || "CALLBACK" + Date.now();
    var JSONP = document.createElement("script");
    JSONP.setAttribute("type", "text/javascript");
    var headEle = document.getElementsByTagName("head")[0];
    var ret = "";

    if (data) {
      if (typeof data === "string") ret = encodeURIComponent(data);else if (_typeof(data) === "object") {
        ret = httpBuildQuery(data);
      }
      ret += "&_time=" + Date.now();
    }

    JSONP.src = "".concat(url, "?callback=").concat(callback, "&").concat(ret);
    console.log(JSONP.src);
    return new Promise(function (resolve, reject) {
      window[callback] = function (r) {
        resolve(r);
        headEle.removeChild(JSONP);
        delete window[callback];
      };

      headEle.appendChild(JSONP);
    });
  }; // 深拷贝 aixos 并创建新的请求拦截和响应拦截


  var imAixos = axios.create();
  imAixos.defaults.baseURL = window.baseURLIm; // 超时时间设置

  imAixos.defaults.timeout = 10000;
  imAixos.interceptors.request.use(function (conf) {
    // console.log('conf', conf)
    var allData = {}; //深拷贝
    // allData = JSON.parse(JSON.stringify(conf))

    for (var key in conf) {
      allData[key] = conf[key];
    }

    var data = allData.data; // console.log('data----->', data)

    var imKey = "JtJ6UuDB1O2tw29MH7AxaDdFKaht0tPH1950367925";
    var timestamp = time();
    var shop_id = "1";
    var sign = window.signim; // 在发送请求之前做些什么

    var user_token = window.localStorage.getItem(config.userTokenKeyIm);
    var BAToken = ras.setDecrypt(ras.privatve, user_token); // console.log('conf', conf)
    // data = {
    //   ...data,
    //   // shop_id: shop_id,
    //   // timestamp: timestamp,
    // };
    // 网络判断
    //网络错误

    if (!window.navigator.onLine) {
      Toast("请检查网络");
      return Promise.reject("请检查网络");
    }

    if (conf.method === "get") {
      // 'X-Requested-With': 'XMLHttpRequest',
      // 	"Accept": "application/json",
      // 	"Content-Type": "application/json; charset=UTF-8",
      // conf.headers = {
      //   ...conf.headers,
      //   "X-Requested-With": "XMLHttpRequest",
      //   "Accept": "application/json",
      //   "Content-Type": "application/json; charset=UTF-8",
      // };
      data = conf.params;
    } else {
      // 'X-Requested-With': 'XMLHttpRequest',
      // 	'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      // conf.headers = {
      //   ...conf.headers,
      //   "X-Requested-With": "XMLHttpRequest",
      //   'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      // };
      data = conf.data;
    } // console.log('data----->22', data)
    // console.log('sign(data)', JSON.stringify(sign(data)))


    var parm = _objectSpread(_objectSpread({}, data), {}, {
      sign: md5(sign(data) + timestamp + imKey)
    });

    if (conf.method === "get") {
      conf.params = parm;
    } else {
      conf.data = parm;
    }

    conf.headers["device"] = 3;
    conf.headers["time"] = timestamp;
    conf.headers["version"] = "1.1.6"; // conf.headers["shop_id"] = shop_id;

    if (user_token) {
      conf.headers["BA-Token"] = BAToken;
    }

    return conf;
  }, function (error) {
    return Promise.reject(error);
  });
  imAixos.interceptors.response.use(function (response) {
    // console.log("response", response);
    //超时处理
    if (response.data.status === "9999") {
      toast(response.data.message);
    }

    return response;
  }, function (error) {
    return Promise.reject(error);
  }); //

  Vue.filter("date", function (value, f) {
    return utils.date(f, value || null);
  });
  Vue.filter("price", function (value) {
    var v = parseFloat(value);
    return v.toFixed(2);
  });
  Vue.filter("imgSrc", function (value) {
    return config.imgSrc + value;
  });
  /**
   * 测试500错误
   */
  // utils.get('/error/500', {
  //     params: {
  //
  //     }
  // }).then(response => {
  //     console.log(response);
  // }).catch(error => {
  //     console.log(error);
  // });

  /**
   * 测试登录失效
   */
  // utils.get('/error/login_valid', {
  //     params: {
  //
  //     }
  // }).then(response => {
  //     console.log(response);
  // }).catch(error => {
  //     console.log(error);
  // });

  var loadingInstance;

  var loading = function loading() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "加载中...";
    loadingInstance = Toast.loading({
      // 持续展示 toast
      duration: 0,
      message: message,
      forbidClick: true
    });
  };

  var loadingClear = function loadingClear() {
    // 统一清除，请求成功后，给500ms的缓冲时间（用户不可操作），为了更好的vue渲染
    setTimeout(function () {
      loadingInstance.clear();
    }, 500);
  };

  var toast = function toast(message) {
    Toast({
      message: message,
      position: "bottom"
    });
  };

  var bindMobileSuccess = function bindMobileSuccess() {
    win.localStorage.clear();
    win.sessionStorage.clear();
    win.location.replace(decodeURIComponent(query("redirect", encodeURIComponent("/"))));
  };

  var utils = {
    config: config,
    local: local,
    localData: local.getItem(),
    session: session,
    sessionData: session.getItem(),
    httpBuildQuery: httpBuildQuery,
    query: query,
    time: time,
    date: date,
    backRefresh: backRefresh,
    goRefresh: goRefresh,
    silentRefresh: silentRefresh,
    backRefreshInit: backRefreshInit,
    backRefreshClear: backRefreshClear,
    isWeiXin: isWeiXin,
    loading: loading,
    loadingClear: loadingClear,
    userTokenKey: config.userTokenKey,
    userTokenKeyIm: config.userTokenKeyIm,
    toast: toast,
    wxLogin: wxLogin,
    bindMobileSuccess: bindMobileSuccess
  };
  Vue.prototype.$http = axios;
  Vue.prototype.imAixos = imAixos;
  Vue.prototype.$utils = utils;
  win.appUtils = utils;
})({
  toastAllowMultiple: true,
  refreshKey: "global.back-refresh",
  refreshDataKey: "global.back-refresh-data",
  // 'http://rap2api.taobao.org/app/mock/271893'
  // baseURL: 'http://zhd-h5-api.test.zsyh99.com',
  userTokenKey: "earch_token",
  userTokenKeyIm: "earch_token_im",
  userMobileBindKey: "global.user_mobile_bind",
  isFirstLeader: "global.is_first_leader",
  userLogin: "global.user_login",
  userWxCode: "global.user_wx_code",
  imgSrc: "https://imgybf.qqybf.com"
}, window, window.vant, window.md5, window.axios, window.Vue, window.appUtilsGlobal, window.$ras);